import React, {Component} from 'react'
import propTypes from 'prop-types'
import {get, isNil, isString} from 'lodash'
import Checkbox from '@material-ui/core/Checkbox'
import Button from 'components/button'
import Icon from 'components/icon'
import {getPartCategoryActionsMenu} from '../utils'

class Node extends Component {

  getNodeIcon = () => {
    const {icon} = this.props
    if (!isNil(icon)) {
      if (isString(icon)) {
        return <Icon name={icon}/>
      } else {
        return icon
      }
    } else {
      return <Icon name='folder_filled'/>
    }
  }

  onClickHandler = () => {
    const {id, onClickHandler} = this.props
    onClickHandler(id)
  }

  onSelectNode = (e) => {
    e.stopPropagation()
    const {node, onSelectNode} = this.props
    onSelectNode(node)
  }

  onCheckNode = (e) => {
    e.stopPropagation()
    const {node, onCheckNode} = this.props
    node['isChecked'] = isNil(node.isChecked) ? true : !node.isChecked
    onCheckNode(node)
  }

  render() {
    const {label, isNodeSelectable, classFtn, node, isMultiSelectable, actions, nodeName} = this.props

    const isChecked = get(node, 'isChecked', false)
    const isDisabled = get(node, 'isDisabled', false)

    return (
      <li className={classFtn(['childNode', nodeName ? nodeName : null])}>
        {isMultiSelectable
          ? (
            <Checkbox
              className={'check-box'}
              style={{width: 24, height: 24}}
              checked={isChecked}
              disabled={isDisabled}
              onChange={this.onCheckNode}
            />
          )
          : null
        }
        <div className={'wrapper'} onClick={this.onClickHandler}>
          <div className={'node-left-container'}>
            <div className={'left'}>
              {this.getNodeIcon()}
              <div className={classFtn('nodeText')}>
                {label}
              </div>
            </div>
            {getPartCategoryActionsMenu(actions, node, false)}
          </div>
          {isNodeSelectable
            ? (
              <Button
                key={'select-node'}
                className={'select-node'}
                label={'Select'}
                onClick={this.onSelectNode}
              />
            )
            : null
          }
        </div>
      </li>
    )
  }
}

Node.propTypes = {
  node: propTypes.object,
  id: propTypes.any,
  label: propTypes.string,
  icon: propTypes.string,
  classFtn: propTypes.func,
  nodeName: propTypes.string,
  isNodeSelectable: propTypes.bool,
  isMultiSelectable: propTypes.bool,
  onClickHandler: propTypes.func,
  onSelectNode: propTypes.func,
  onCheckNode: propTypes.func,
  isChecked: propTypes.bool,
  actions: propTypes.array,
}

Node.defaultProps = {
  label: '',
  isNodeSelectable: false,
  isMultiSelectable: false,
  isChecked: false,
  actions: [],
  classFtn: (input) => (input),
}

export default Node
